import { Link } from 'react-router-dom'
import { Footer, SECTIONS } from '../components/layout/Footer.jsx'
import { APP_NAME, APP_TAGLINE } from '../utils/constants.js'

// Standalone Terms of Service page. See PrivacyPage.jsx — same
// motivation, same SECTIONS source of truth. UX31.
export function TermsPage() {
  return (
    <div className="app-shell">
      <header className="header">
        <div className="header-inner">
          <div className="brand">
            <Link to="/" className="brand-text" style={{ color: 'inherit', textDecoration: 'none' }}>
              <span className="brand-name">{APP_NAME}</span>
              <span className="brand-tagline">{APP_TAGLINE}</span>
            </Link>
          </div>
        </div>
      </header>

      <main className="legal-page">
        <h1>{SECTIONS.terms.title}</h1>
        <div className="legal-page-body">
          {SECTIONS.terms.body}
        </div>
        <p className="legal-page-back">
          <Link to="/">← Back to {APP_NAME}</Link>
        </p>
      </main>

      <Footer />
    </div>
  )
}
